import React, { PropTypes } from 'react';

const LOGO = "https://www.crowdspring.com/blog/wp-content/uploads/2020/03/cs-200px.png";

const FeaturedContent = ({ title, content, hideLogo, titleAlignment }) => {
  return (
    <section className="block block-featured-content">
      <div className="row align-center">
        <div className="columns small-16 large-10">
          <div className="box">
            <h2 className={`text-${titleAlignment || "left"}`}>{ title }</h2>
            <div className="content" dangerouslySetInnerHTML={{ __html: content }} />
            { !hideLogo && <img className="logo" src={LOGO} /> }
          </div>
        </div>
      </div>
    </section>
  );
}

FeaturedContent.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  hideLogo: PropTypes.bool,
  titleAlignment: PropTypes.string,
};

export default FeaturedContent;
